export var CookieConsentValue;
(function (CookieConsentValue) {
    CookieConsentValue["Accepted"] = "accepted";
    CookieConsentValue["Rejected"] = "rejected";
    CookieConsentValue["NotSet"] = "";
})(CookieConsentValue || (CookieConsentValue = {}));
export const cookieConsent = 'cookieconsent';
